import { render, staticRenderFns } from "./ObjectAttachmentPopUp.vue?vue&type=template&id=6ecf77ac&scoped=true"
import script from "./ObjectAttachmentPopUp.vue?vue&type=script&lang=js"
export * from "./ObjectAttachmentPopUp.vue?vue&type=script&lang=js"
import style0 from "./ObjectAttachmentPopUp.vue?vue&type=style&index=0&id=6ecf77ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf77ac",
  null
  
)

export default component.exports